import { useAppSelector } from 'store/index';

export const useIsExpandedMenu = (id: string) => {
    return useAppSelector(state => state.expandedMenu.expanded[id]);
};

export const useIsAllExpanded = () => {
    return useAppSelector(state => state.expandedMenu.allExpanded);
};
